import React from "react";

const PublishSaleModal = ({ isOpen, onClose, onConfirm, saleData, loading = false }) => {
  if (!isOpen) return null;

  const handleConfirm = () => {
    if (onConfirm) {
      onConfirm();
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal-container">
        <div className="modal-content">
          <h3 className="publish-modal-title">Publish Sale</h3>
          <p className="publish-modal-message">
            Are you sure you want to publish this sale? This action cannot be
            undone.
          </p>

          <div className="sale-summary">
            <div className="summary-row">
              <span className="summary-row-label">Total Amount</span>
              <span className="summary-row-value">
                €{saleData?.totalAmount?.toFixed(2) || "0.00"}
              </span>
            </div>

            <div className="summary-row">
              <span className="summary-row-label">Paid Amount</span>
              <span className="summary-row-value">
                €{saleData?.paidAmount?.toFixed(2) || "0.00"}
              </span>
            </div>
            
            <div className="summary-row">
              <span className="resulting-balance-summary-row-label">Resulting Balance</span>
              <span className="resulting-balance-summary-row-value">
                €{saleData?.resultingBalance?.toFixed(2) || "0.00"}
              </span>
            </div>
          </div>
        </div>

        <div className="modal-footer">
          <button className="btn-secondary" onClick={onClose}>
            Cancel
          </button>
          <button 
            className="btn-primary" 
            onClick={handleConfirm}
            disabled={loading}
          >
            {loading ? 'Publishing...' : 'Confirm Publish'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default PublishSaleModal;
